module.exports = __webpack_public_path__ + "img/product-preview-72.c62d073.png";